import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

/* variants constants */
const UNDERLINED = "underlined";
const OUTLINED = "outlined";
const UNDERLINED2 = "underlined2";
const DEFAULT = "default";

const variantClasses = {
  [DEFAULT]: "",
  [UNDERLINED]: "border-b border-gray-700 focus:border-primary",
  [OUTLINED]: "border border-gray-200 px-3 focus:border-primary",
  [UNDERLINED2]: "border-b border-gray-300 focus:border-primary",
};

const TextField = ({
  variant = UNDERLINED,
  className,
  wrapperClassName,
  label,
  multiline = false,
  inputRef,
  validationError,
  startIcon,
  ...props
}) => {
  const classes = classNames(
    "text-base focus:outline-none rtl:text-right",
    variantClasses[variant],
    className
  );

  const Tag = multiline ? "textarea" : "input";

  // if (multiline)
  //   return (
  //     <>
  //       <textarea className={classes} ref={inputRef} {...props} />
  //       {validationError && (
  //         <span className="mt-1 block text-red-500">
  //           {validationError.message}
  //         </span>
  //       )}
  //     </>
  //   );

  return (
    <div
      className={classNames("input-wrapper", wrapperClassName, {
        "px-5 py-2 rounded-md": variant === UNDERLINED2,
        relative: Boolean(startIcon),
      })}
    >
      {startIcon && (
        <div
          // this height style shouldn't be here. it was done to achieve a baseline centering for the icon to match the text, and shouldn't be centered in beyond 48px height container
          // idk if this makes sense
          style={{ height: "48px" }}
          className="absolute ltr:left-0 h-12 rtl:right-0 ltr:pl-3 rtl:pr-3 flex items-center pointer-events-none"
        >
          {startIcon}
        </div>
      )}
      <Tag
        type={!multiline ? "text" : undefined}
        className={classes}
        ref={inputRef}
        {...props}
      />
      {validationError && (
        <span className="mt-1 block text-red-500">
          {validationError.message}
        </span>
      )}
    </div>
  );
};

TextField.propTypes = {
  variant: PropTypes.oneOf([UNDERLINED, OUTLINED, UNDERLINED2, DEFAULT]),
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  multiline: PropTypes.bool,
  label: PropTypes.string,
  startIcon: PropTypes.node,
};

export default TextField;
